import React__default, { memo, useContext, useRef } from 'react';
import cn from 'classnames';
import styles from 'ui-components/Slider.scss';
import { SliderContext } from './context.js';
import { useOnClickDrag } from './utils.js';

var KEY_LEFT = 37;
var KEY_RIGHT = 39;
var KEY_UP = 38;
var KEY_DOWN = 40;
var LEAP_INCREMENT = 10;
var Handle = /*#__PURE__*/memo(function (_ref) {
  var _cn;
  var value = _ref.value,
    onChange = _ref.onChange;
  var _useContext = useContext(SliderContext),
    orientation = _useContext.orientation,
    reverse = _useContext.reverse,
    valueToPercent = _useContext.valueToPercent,
    coordsToValue = _useContext.coordsToValue,
    clamp = _useContext.clamp,
    stepSize = _useContext.stepSize;
  var element = useRef(null);
  var horizontal = orientation === "horizontal";
  var percent = valueToPercent(value);
  var reversePercent = Math.abs(percent - 100);
  var _useOnClickDrag = useOnClickDrag(element.current, function (pos) {
      if (onChange) {
        var _value = coordsToValue(pos);
        if (typeof _value === "number" && !isNaN(_value)) {
          onChange(_value);
        }
      }
    }),
    onMouseDown = _useOnClickDrag.onMouseDown,
    onTouchStart = _useOnClickDrag.onTouchStart,
    isActive = _useOnClickDrag.isActive;
  var wrapperStyle = {
    position: "absolute",
    top: 0,
    bottom: 0,
    left: 0,
    willChange: "transform",
    height: horizontal ? "0px" : "auto",
    width: horizontal ? "100%" : "0px",
    transform: horizontal ? "translateX(-" + (reverse ? percent : reversePercent) + "%)" : "translateY(" + (reverse ? percent : reversePercent) + "%)"
  };
  var handleStyle = {
    willChange: "transform",
    touchAction: "none",
    userSelect: "none",
    WebkitUserDrag: "none",
    right: horizontal ? "0px" : "auto",
    bottom: !horizontal ? "0px" : "auto",
    top: !horizontal ? "0px" : "auto",
    transform: horizontal ? "translateX(50%)" : "translateY(-50%)"
  };
  return /*#__PURE__*/React__default.createElement("div", {
    style: wrapperStyle
  }, /*#__PURE__*/React__default.createElement("button", {
    ref: element,
    type: "button",
    role: "slider",
    "aria-orientation": orientation,
    "aria-valuenow": value,
    "aria-valuetext": value,
    className: cn(styles.handle, (_cn = {}, _cn[styles.handle__active] = isActive, _cn)),
    style: handleStyle,
    onMouseDown: onMouseDown,
    onTouchStart: onTouchStart,
    onKeyDown: function onKeyDown(e) {
      switch (e.keyCode) {
        case KEY_LEFT:
          return onChange(clamp(value - stepSize));
        case KEY_RIGHT:
          return onChange(clamp(value + stepSize));
        case KEY_DOWN:
          return onChange(clamp(value - stepSize * LEAP_INCREMENT));
        case KEY_UP:
          return onChange(clamp(value + stepSize * LEAP_INCREMENT));
      }
    }
  }));
});

export { Handle };
//# sourceMappingURL=handle.js.map
